import React, { useState, useEffect, useRef } from "react";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { ArrowBack, Visibility, VisibilityOff } from "@mui/icons-material";
import Header from "../header/Header";
import Sidebar from "./dashboard/AppSideBar";
import BreadCrumbs from "../../generalComponnets/breadCrumbs/BreadCrumbs";
import CloseIcon from "@mui/icons-material/Close";
import WarningIcon from "@mui/icons-material/Warning";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import InfoIcon from "@mui/icons-material/Info";

import {
  breadcrumbMap,
  checkAndConvertToHTML,
  path,
  profilepath,
} from "../../utils/Constant";
import {
  Avatar,
  Box,
  DialogContent,
  DialogContentText,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  ListItemIcon,
  Menu,
  MenuItem,
  Select,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  complete_profile_update_api,
  sections_inside_source_api,
  get_all_sectors_by_client_type,
  reset_enhanced_password_api,
} from "../../DAL/TalentSourceAPI/TalentSourceApi";
import { useIds } from "../../hook/AdminContext";
import { Button, Dialog, DialogActions, DialogTitle } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { getPasswordStrength } from "../menu/PasswirdStrength";
import TextEditor from "../editors/ReactEditor";
import { s3baseUri } from "../../config/config";
import CropPopUp from "../userslistToolbars/CCropPopUp";
import CameraAltIcon from "@mui/icons-material/CameraAltOutlined";
import PersonIcon from "@mui/icons-material/PersonOutline";
import GeneralMuiModal from "../menu/MenuModalMui";
import FixedSizeImageCropper from "../FixedSizeImageCropper/FixedSizeImageCropper";
import { get_active_sources } from "../../DAL/general-apis/general-apis";
import CircularLoader from "../loader/CircularLoader";
import MailFallbackModal from "../MailFallbackModal/MailFallbackModal";
import ProfileDialog from "../ProfileDialog/ProfileDialog";
import ReportPostJobModal from "../../pages/ReportPage/ReportPostJobModal";
import ProfileSwitchLoader from "../loader/ProfileSwitchLoader";
import Footer from "../../pages/Footer/Footer";

const DashboardLayout = () => {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();
  const path = location.pathname;

  const token = localStorage.getItem("token");
  const user = localStorage.getItem("user");

  if (!token || !user) {
    localStorage.clear();
    navigate("/login");
  }
  const clientTypeLabels = {
    clients: "Client",
    agency_partner: "Agency Partner",
    industry_partner: "Industry Partner",
    industry_suppliers: "Industry Supplier",
  };
  const [currentSidebar, setCurrentSidebar] = useState("main");
  const [crop, setCrop] = useState({
    unit: "%",
    width: 95,
    height: 95,
    x: 2.5,
    y: 2.5,
  });

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [showPasswordFields, setShowPasswordFields] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showRequirements, setShowRequirements] = useState(false);
  const [adjustedHeight, setAdjustedHeight] = useState("100vh");

  const [isUpdateing, setIsUpdating] = useState(false);
  const fileInputRef = useRef(null);

  const [file, setFile] = useState(null);

  const [croppedImage, setCroppedImage] = useState(null);

  const [dynamicHeight, setDynamicHeight] = useState("100vh");

  const { pathname } = useLocation();
  const theme = useTheme();
  const [openDelete, setOpenDelete] = useState(true);
  const [loadMorePath, setLoadMorePath] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");

  const [sourceId, setsourceId] = useState(null);
  const observer = useRef();
  const [categories, setCategories] = useState([]);
  const [partnersObj, setPartnersObj] = useState({});
  const [imageRef, setImageRef] = useState(null);
  const [cropModalOpen, setCropModalOpen] = useState(false);
  const handleViewProfile = () => {
    setInputs((old) => ({ ...old, dialogOpen: true }));
    handleMenuClose();
  };

  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const handleMenuOpen = (event) => {
    setInputs((old) => ({ ...old, anchorEl: event.currentTarget }));
  };
  const makeClientCrop = async (crop) => {
    if (imageRef && crop.width && crop.height) {
      const result = await getCroppedImg(imageRef, crop);

      // Set preview URL for display
      setCroppedImage(result.previewUrl);

      // Set the actual file object in inputs for form submission
      setInputs((prev) => ({ ...prev, image: result.file }));
    }
  };

  const handleCropImage = async () => {
    if (!imageRef) {
      alert("Image not loaded");
      return;
    }

    let finalCrop = crop;

    // Convert percentage crop to pixel crop if needed
    if (crop.unit === "%") {
      finalCrop = {
        unit: "px",
        x: (crop.x / 100) * imageRef.width,
        y: (crop.y / 100) * imageRef.height,
        width: (crop.width / 100) * imageRef.width,
        height: (crop.height / 100) * imageRef.height,
      };
    }

    const result = await getCroppedImg(imageRef, finalCrop);
    setCroppedImage(result.previewUrl); // Preview
    setInputs((prev) => ({ ...prev, image: result.file })); // Save for API
    setCropModalOpen(false);
  };
  const getCroppedImg = (image, crop) => {
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx = canvas.getContext("2d");

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    return new Promise((resolve) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          console.error("Canvas is empty");
          return;
        }

        // Create file object for form submission
        const croppedFile = new File([blob], "cropped.jpeg", {
          type: "image/jpeg",
        });

        // Create preview URL
        const previewUrl = window.URL.createObjectURL(blob);

        resolve({ file: croppedFile, previewUrl });
      }, "image/jpeg");
    });
  };
  const onImageLoaded = (e) => {
    setImageRef(e.target); // e.target is the actual img element
  };
  const onCropComplete = async (crop) => {
    await makeClientCrop(crop);
  };
  const fileChangedHandler = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    // Handle SVG files differently
    if (file.type === "image/svg+xml") {
      const reader = new FileReader();
      reader.onload = () => {
        // Directly set the SVG as preview and file
        setCroppedImage(reader.result);
        setInputs((prev) => ({ ...prev, image: file }));
      };
      reader.readAsDataURL(file);
      return; // Skip the cropping modal for SVG
    }

    // Original handling for other image types
    const reader = new FileReader();
    reader.onload = () => {
      setFile(reader.result);
      setCropModalOpen(true);
    };
    reader.readAsDataURL(file);

    // setCrop({
    //   unit: "%",
    //   width: 95,
    //   height: 95,
    //   x: 2.5,
    //   y: 2.5,
    // });

    // setCroppedImage(null);
    // setInputs((prev) => ({ ...prev, image: null }));
    e.target.value = "";
  };
  const handleSaveFullImage = () => {
    if (file) {
      // Convert base64 to file object
      fetch(file)
        .then((res) => res.blob())
        .then((blob) => {
          const fullImageFile = new File([blob], "full-image.jpeg", {
            type: "image/jpeg",
          });

          // Set the full image in inputs
          setInputs((prev) => ({ ...prev, image: fullImageFile }));

          // Set preview (use the original file as preview)
          setCroppedImage(file);

          // Close modal
          setCropModalOpen(false);
        });
    }
  };

  const handleMenuClose = () => {
    setInputs((old) => ({ ...old, anchorEl: null }));
  };

  const INITIAL_VALUES = {
    first_name: "",
    email: "",
    anchorEl: null,
    avatar: "",
    dialogOpen: false,
    loading: false,
    last_name: "",
    post_code: "",
    contact_number: "",
    status: true,
    company_name: "",
    contact_name: "",
    twitter_link: "",
    youtube: "",
    linkedIn_link: "",
    facebook_link: "",
    instagram_link: "",
    location: "",
    website: "",
    street_address: "",
    state: "",
    city: "",
    country: "",
    about: "",
    image: "",
    password: "",
    confirm_password: "",
    title: "",
    lastName: "",
  };

  const [inputs, setInputs] = useState(INITIAL_VALUES);
  const [loading, setLoading] = useState(false);
  const [sectors, setSectors] = useState({}); // Store sectors by client type

  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const {
    setActiveSourceList,
    breadCrumb,
    setUserInfo,
    fetctUserDetail,
    userInfo,
    findId,
    userAPIData,
    emailFallBackOpen,
    setEmailFallBackOpen,
    emailData,
    openReportPost,
    setOpenReportPost,
    reportData,
    profileSwitchLoader,
  } = useIds();
  const load_more_path = "api/jobs/list?page=0&limit=50";

  const fetchSources = async () => {
    if (!localStorage.getItem("token")) return;
    const response = await get_active_sources();
    if (response.code === 200) {
      setActiveSourceList(response.sources);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputs((old) => ({ ...old, [name]: value }));
  };
  const handlePasswordChange = () => {
    // Add your password change logic here
    // Validate passwords match, make API call, etc.
  };

  const handleDelete = async () => {
    setOpenDelete(false);
  };
  const handleBack = () => {
    setShowPasswordFields(false);
    setNewPassword("");
    setOldPassword("");
    setConfirmPassword("");
  };

  const fetchSectors = async () => {
    const clientTypes = userInfo?.client_type || [];
    if (clientTypes.length === 0) return;

    setLoading(true);

    try {
      // Helper to normalize slug
      const getSlug = (clientTypeObj) => {
        if (typeof clientTypeObj === "string") return clientTypeObj;
        if (clientTypeObj && typeof clientTypeObj === "object") {
          return (
            clientTypeObj.slug ||
            clientTypeObj.title?.toLowerCase().replace(/\s+/g, "_")
          );
        }
        return null;
      };

      // Prepare API calls
      const requests = clientTypes
        .map((obj) => getSlug(obj))
        .filter(Boolean) // remove nulls
        .map(async (slug) => {
          try {
            const response = await get_all_sectors_by_client_type(
              "",
              50,
              0,
              slug
            );

            if (response.code === 200) {
              return { slug, sectors: response?.data?.sectors || [] };
            } else {
              enqueueSnackbar(`Failed to fetch sectors for ${slug}`, {
                variant: "error",
              });
              return { slug, sectors: [] };
            }
          } catch (err) {
            console.error(`Error fetching ${slug}:`, err);
            enqueueSnackbar(`Error fetching sectors for ${slug}`, {
              variant: "error",
            });
            return { slug, sectors: [] };
          }
        });

      // Run all in parallel
      const results = await Promise.all(requests);

      // Build object
      const sectorsData = results.reduce((acc, { slug, sectors }) => {
        acc[slug] = sectors;
        return acc;
      }, {});

      setInputs((prev) => ({
        ...prev,
        clientTypeHavingSectors: getClientTypeHavingSectors(sectorsData),
      }));

      setSectors(sectorsData);
    } catch (error) {
      enqueueSnackbar("Error fetching sectors", { variant: "error" });
    } finally {
      setLoading(false);
    }
  };

  const handleSectorChange = (slug, newSectorId) => {
    setInputs((prev) => ({
      ...prev,
      clientTypeHavingSectors: prev.clientTypeHavingSectors.map((clientType) =>
        clientType.slug === slug
          ? {
              ...clientType,
              sector: {
                ...clientType.sector,
                slug: newSectorId,
              },
            }
          : clientType
      ),
    }));
  };

  const getClientTypeHavingSectors = (sectorObj) => {
    // Step 1: filter client types that have sector arrays in sectorObj
    let typeArrayWithSector = (userInfo?.client_type || []).filter(
      (obj) => sectorObj[obj.slug]?.length > 0
    );

    // Step 2: enrich sector only if slug is missing
    return typeArrayWithSector.map((clientType) => {
      const hasSlug = clientType.sector?.slug;

      if (!hasSlug) {
        const matchedSector = sectorObj[clientType.slug]?.find(
          (s) => s._id === clientType.sector?.sector_id
        );

        if (matchedSector) {
          return {
            ...clientType,
            sector: {
              ...clientType.sector,
              slug: matchedSector.slug,
            },
          };
        } else {
          return {
            ...clientType,
            sector: {
              ...clientType.sector,
              slug: "",
            },
          };
        }
      }

      return clientType; // unchanged if slug already exists or no match
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (userInfo?.is_temporary_password === true) {
      if (!inputs.password) {
        enqueueSnackbar("New password is required", { variant: "error" });
        return;
      }

      const passwordErrors = [];
      if (inputs.password.length < 8)
        passwordErrors.push("at least 8 characters");
      if (!/[A-Z]/.test(inputs.password))
        passwordErrors.push("one uppercase letter");
      if (!/[a-z]/.test(inputs.password))
        passwordErrors.push("one lowercase letter");
      if (!/[0-9]/.test(inputs.password)) passwordErrors.push("one number");
      if (!/[^A-Za-z0-9]/.test(inputs.password))
        passwordErrors.push("one special character");

      if (passwordErrors.length > 0) {
        enqueueSnackbar(`Password must contain: ${passwordErrors.join(", ")}`, {
          variant: "error",
        });
        return;
      }

      if (inputs.password !== inputs.confirm_password) {
        enqueueSnackbar("New Password and confirm New Password don't match", {
          variant: "error",
        });
        return;
      }
    }

    // URL validation function
    const validateUrl = (url) => {
      if (url && !/^https?:\/\//i.test(url)) {
        return false; // Invalid URL
      }
      return true; // Valid URL
    };

    // Validate social media URLs if provided (optional fields) - Always run this validation
    const socialMediaFields = [
      { name: "facebook_link", label: "Facebook URL" },
      { name: "linkedIn_link", label: "LinkedIn URL" },
      { name: "instagram_link", label: "Instagram URL" },
      { name: "youtube", label: "YouTube URL" },
      { name: "twitter_link", label: "Twitter URL" },
    ];

    for (const field of socialMediaFields) {
      const value = inputs[field.name]?.trim();

      // Only validate if user has provided a value
      if (value && !validateUrl(value)) {
        enqueueSnackbar(`${field.label} must start with http:// or https://`, {
          variant: "error",
        });
        return;
      }
    }

    if (userInfo?.is_profile_completed === false) {
      const hasNewImage = inputs?.image && typeof inputs.image !== "string";
      const hasOldImage = croppedImage && typeof croppedImage === "string";
      const hasExistingImage =
        userInfo?.profile_image?.thumbnail_1 || userInfo?.profile_image;

      if (!hasNewImage && !hasOldImage && !hasExistingImage) {
        enqueueSnackbar("Profile image is required", { variant: "error" });
        return;
      }

      const requiredFields = [
        { name: "company_name", label: "Company name" },
        { name: "contact_name", label: "Contact name" },
        { name: "contact_number", label: "Contact number" },
        { name: "post_code", label: "Post code" },
        { name: "location", label: "Location" },
        { name: "email", label: "Email" },
        { name: "website", label: "Website" },
        { name: "about", label: "About Yourself" },
      ];

      for (const field of requiredFields) {
        const value = inputs[field.name]?.trim();

        // Required check
        if (!value) {
          enqueueSnackbar(`${field.label} is required`, { variant: "error" });
          return;
        }

        if (["website"].includes(field.name)) {
          if (!validateUrl(value)) {
            enqueueSnackbar(
              `${field.label} must start with http:// or https://`,
              { variant: "error" }
            );
            return;
          }
        }
      }

      // Check if any client type requires sector selection
      if (inputs?.clientTypeHavingSectors?.length > 0) {
        const hasSelectedSectors = inputs?.clientTypeHavingSectors.every(
          (clientType) => {
            return clientType.sector && clientType.sector.slug;
          }
        );

        if (!hasSelectedSectors) {
          enqueueSnackbar(
            "Sector selection is required for all applicable client types",
            { variant: "error" }
          );
          return;
        }
      }
    }

    setInputs((prev) => ({ ...prev, loading: true }));
    setIsUpdating(true);
    const is_image_exists = inputs.image;
    const is_image_uploaded = croppedImage && typeof croppedImage === "string";
    const hasExistingImage =
      userInfo?.profile_image?.thumbnail_1 || userInfo?.profile_image;

    // Debug the image states

    // Only require image if user is completing profile for the first time
    if (
      userInfo?.is_profile_completed === false &&
      !is_image_exists &&
      !is_image_uploaded
    ) {
      enqueueSnackbar("Profile image is required", { variant: "error" });
      setIsUpdating(false);
      setInputs((prev) => ({ ...prev, loading: false }));
      return;
    }

    try {
      const formData = new FormData();
      if (userInfo?.is_temporary_password === true) {
        formData.append("password", inputs.password);
        formData.append("confirm_password", inputs.confirm_password);
      }

      formData.append("company_name", inputs.company_name);
      formData.append("location", inputs.location);
      formData.append("email", inputs.email);
      formData.append("contact_number", inputs.contact_number);
      formData.append("post_code", inputs.post_code);
      formData.append("linkedin", inputs.linkedIn_link);
      formData.append("youtube", inputs.youtube);
      formData.append("twitter", inputs.twitter_link);
      formData.append("instagram", inputs.instagram_link);
      formData.append("facebook", inputs.facebook_link);
      formData.append("contact_name", inputs.contact_name);
      formData.append("website", inputs.website);
      formData.append("about", inputs.about);
      formData.append("client_type", getClientType());
      // Debug logging

      if (is_image_uploaded) {
        console.log("is_image_uploaded");
        // Use croppedImage only if no existing image from userInfo
        const response = await fetch(croppedImage);
        const blob = await response.blob();
        const urlParts = croppedImage.split("/");
        const filename = "profile_image.jpg";
        const file = new File([blob], filename, { type: blob.type });
        formData.append("image", file);
      } else {
        console.log(
          "No image found - this should not happen if validation passed"
        );
      }

      const response = await complete_profile_update_api(formData);

      if (response.code === 200) {
        const data = { ...response.data };

        setInputs((old) => ({ ...old, ...data }));
        const updatedUser = {
          ...response.data,
          is_temporary_password: false,
          is_profile_completed: true,
        };
        await fetctUserDetail();
        setOpenDelete(false);
        setIsUpdating(false);
        setIsUpdating(false);

        enqueueSnackbar(response?.message, {
          variant: "success",
        });
      } else {
        enqueueSnackbar(response.message, { variant: "error" });
      }
    } catch (error) {
      console.log(error, "errorerrorerrorerrorerror");
      enqueueSnackbar("An error occurred while updating", { variant: "error" });
    } finally {
      setInputs((prev) => ({ ...prev, loading: false }));
      setIsUpdating(false);
    }
  };
  const handleSubmitCandidate = async () => {
    if (userInfo?.is_temporary_password === true) {
      if (!inputs.password) {
        enqueueSnackbar("New password is required", { variant: "error" });
        return;
      }

      const passwordErrors = [];
      if (inputs.password.length < 8)
        passwordErrors.push("at least 8 characters");
      if (!/[A-Z]/.test(inputs.password))
        passwordErrors.push("one uppercase letter");
      if (!/[a-z]/.test(inputs.password))
        passwordErrors.push("one lowercase letter");
      if (!/[0-9]/.test(inputs.password)) passwordErrors.push("one number");
      if (!/[^A-Za-z0-9]/.test(inputs.password))
        passwordErrors.push("one special character");

      if (passwordErrors.length > 0) {
        enqueueSnackbar(`Password must contain: ${passwordErrors.join(", ")}`, {
          variant: "error",
        });
        return;
      }

      if (inputs.password !== inputs.confirm_password) {
        enqueueSnackbar("New Password and confirm New Password don't match", {
          variant: "error",
        });
        return;
      }
    }
    setInputs((prev) => ({ ...prev, loading: true }));
    const data = {
      password: inputs.password,
      confirm_password: inputs.confirm_password,
    };
    try {
      const response = await reset_enhanced_password_api(data);
      if (response.code === 200) {
        await fetctUserDetail();
        enqueueSnackbar(response?.message, {
          variant: "success",
        });
        setOpenDelete(false);
        setIsUpdating(false);
      } else {
        enqueueSnackbar(response.message, { variant: "error" });
        // setUserInfo((prev) => ({ ...prev, is_temporary_password: false }));
      }
    } catch (error) {
      enqueueSnackbar("An error occurred while submitting candidate", {
        variant: "error",
      });
    } finally {
      setInputs((prev) => ({ ...prev, loading: false }));
    }
  };

  const getClientType = () => {
    if (!Array.isArray(inputs?.client_type)) return "[]";

    const mapped = inputs.client_type.map((obj) => {
      // find matching client type in clientTypeHavingSectors by slug
      const match = inputs.clientTypeHavingSectors?.find(
        (ct) => ct.slug === obj.slug
      );

      return {
        slug: obj.slug,
        sector_slug: match?.sector?.slug || obj?.sector?.slug || "",
      };
    });

    return JSON.stringify(mapped);
  };

  useEffect(() => {
    if (userInfo) {
      setInputs((old) => ({
        ...old,
        ...userInfo,
        password: "",
        instagram_link: userInfo.social_links?.instagram,
        facebook_link: userInfo.social_links?.facebook,
        twitter_link: userInfo.social_links?.twitter,
        linkedIn_link: userInfo.social_links?.linkedin,
        youtube: userInfo.social_links?.youtube,
        contact_name: userInfo?.contact_name,
        street_address: userInfo?.street || userInfo?.address?.street,
        post_code: userInfo?.address?.post_code || userInfo?.post_code,
        about: userInfo?.about
          ? checkAndConvertToHTML(userInfo?.about)
          : userInfo?.about,
        image: userInfo?.profile_image?.thumbnail_1 || "",
        email: userInfo?.email,
        title: userInfo?.company_name,
        lastName: userInfo?.location,
        location: userInfo?.location,
        company_name: userInfo?.company_name,
        contact_number: userInfo?.contact_number,
        website: userInfo?.website_url,
      }));
    }
  }, [userInfo]);
  const fecthFeatures = async () => {
    const response = await sections_inside_source_api(0, 100, "");

    if (response.code === 200) {
      // if (response?.user_detail) {
      //   setUserInfo(response.user_detail);
      //   localStorage.setItem("user", JSON.stringify(response.user_detail));
      // }
      localStorage.setItem(
        "section_inside_source_data",
        JSON.stringify(response.feature)
      );
      // setSourceSectionIds(response?.feature);
    }
  };
  const handleUpdateImage = () => {
    fileInputRef.current.click();
    handleMenuClose();
  };

  const breadcrumbsList = (items) => {
    const homeItem = {
      name: (
        <>
          <ArrowBack className="arrow-back" /> Sources
        </>
      ),
      path: "/home",
      active: false,
    };
    const dynamicItems = items?.map((item) => ({
      name: item.name,
      path: item.path,
      active: item.active,
    }));

    return [homeItem, ...dynamicItems];
  };

  const isMobile = useMediaQuery("(max-width:600px)");

  const excludedPaths = ["/home/favourite-jobs", "/home/candidates"];

  const startsWithPaths = [
    // "/home/favourite-jobs/job-detail",
    // "/profile",
    "/hospitality/favourite-jobs",

    "/hospitality/favourite-jobs",
    "/warehouse/favourite-jobs",
    "/fit-out-source/favourite-jobs",
    "/healthcare/favourite-jobs",
    "/office-source/favourite-jobs",
    "/retail-source/favourite-jobs",
    "/construction-source/favourite-jobs",
    "/fit-out-source/favourite-jobs",
    // "/favourite-jobs",
    // "/home/candidates",
    // "/hospitality/candidates",
    // "/warehouse/candidates",
    // "/healthcare/candidates",
    // "/office-source/candidates",
    // "/retail-source/candidates",
    // "/construction-source/candidates",
    // "/fit-out-source/candidates",
    // "/home/feed-job-detail",
    // "/hospitality/feed-job-detail",
    // "/warehouse/feed-job-detail",
    // "/healthcare/feed-job-detail",
    // "/healthcare/feed-job-detail",
    // "/office-source/feed-job-detail",
    // "/retail-source/feed-job-detail",
    // "/food-source/feed-job-detail",
    // "/construction-source/feed-job-detail",
    // "/fit-out-source/feed-job-detail",
    // "/hospitality/feed-job-detail",
    // "/food-source/candidates",
    "/food-source/live-job-feed/job-candidates-page",
    // "/hospitality/applied-jobs",
    // "/home/applied-jobs",
    // "/warehouse/applied-jobs",
    // "/retail-source/applied-jobs",
    // "/construction-source/applied-jobs",
    // "/food-source/applied-jobs",
    // "/healthcare-source/applied-jobs",
    // "/office-source/applied-jobs",
    // "/fit-out-source/applied-jobs",
  ];
  const handleDialogClose = () => {
    setInputs((old) => ({ ...old, dialogOpen: false }));
  };

  const firstSegment = location.pathname.split("/")[1];
  const isFavouriteJobs = pathname === "/favourite-jobs";
  const isFeedJobDetail = pathname.startsWith(
    `/${firstSegment}/feed-job-detail/`
  );
  const candidates = pathname.startsWith(`/${firstSegment}/candidates/`);
  const showHeader =
    isSmallScreen && (isFavouriteJobs || isFeedJobDetail || candidates);
  const fullScreenHeight = window.screen.height;

  // const showHeader =
  //   pathname === "/favourite-jobs" ||

  const shouldHideSidebar =
    excludedPaths?.includes(pathname) ||
    startsWithPaths?.some((path) => pathname.startsWith(path)) ||
    pathname === "/my-job-posts";

  useEffect(() => {
    // fetchSources();
    // fecthFeatures();
  }, []);

  useEffect(() => {
    if (userInfo?.client_type) {
      fetchSectors();
    }
  }, [userInfo?.client_type]);
  useEffect(() => {
    const handleResize = () => {
      const zoomLevel = window.devicePixelRatio;
      const baseHeight = window.innerHeight;

      // Increase height when zoomed out
      if (zoomLevel < 1) {
        const extraSpace = (1 - zoomLevel) * 100;
        setDynamicHeight(`calc(100vh + ${extraSpace}px)`);
      } else {
        setDynamicHeight("100vh");
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    if (
      pathname === "/home" ||
      pathname === "/profile" ||
      pathname === "/manage-users" ||
      pathname === "/invitations" ||
      pathname === "/home/applied-jobs" ||
      pathname.includes("payment-requests") ||
      pathname.includes("payment-done") ||
      pathname === "/payment-requests/accepted-request" ||
      pathname.startsWith("/favourite-jobs") ||
      pathname.startsWith("/applied-jobs") ||
      pathname.startsWith("/home/candidates") ||
      pathname.startsWith("/payment-request-details")
    ) {
      setCurrentSidebar("main");
    } else {
      setCurrentSidebar("new_side_bar");
    }
  }, [pathname]);

  useEffect(() => {
    if (
      userInfo?.is_temporary_password === true ||
      userInfo?.is_profile_completed === false
    ) {
      setOpenDelete(true);
    }
  }, [userInfo]);

  const checkPathAccordingProfileAccess = () => {
    let pathsList = [
      {
        path: "/manage-users",
        accessValue: "manage_profile?.manage_user",
      },
      {
        path: "/profile",
        accessValue: "manage_profile?.company_profile",
      },
      {
        path: "/job-settings",
        accessValue: ["job?.add", "job?.update"],
        isMultiple: true,
      },

      {
        path: "/profile/",
        accessValue: "manage_profile?.company_profile",
        checkIncludes: true,
      },
      {
        path: "/profile/manage-affiliate",
        accessValue: "manage_profile?.company_profile",
        checkIncludes: true,
      },
    ];

    for (const item of pathsList) {
      let pathMatch = item.checkIncludes
        ? path.includes(item.path)
        : path == item.path;
      if (pathMatch) {
        if (userInfo.isCompanyProfile) {
          if (item.isMultiple) {
            const hasAtLeastOne = item.accessValue.some((key) =>
              eval(`userInfo?.company_access?.${key}`)
            );
            if (!hasAtLeastOne) {
              navigate("/home", { replace: true });
              return false;
            }
          } else {
            if (!eval(`userInfo?.company_access?.${item.accessValue}`)) {
              navigate("/home", { replace: true });
              return false;
            }
          }
        }
      }
    }
    return true;
  };

  const checkPathsThatOnlyCandidatesHasAccess = () => {
    let pathsList = [
      {
        path: "/applied-jobs",
        checkIncludes: true,
      },
      {
        path: "/favourite-jobs",
      },
      {
        path: "/favourite-jobs/",
        checkIncludes: true,
      },
      {
        path: "/cv-management",
      },
    ];

    for (const item of pathsList) {
      let pathMatch = item.checkIncludes
        ? path.includes(item.path)
        : path == item.path;
      if (pathMatch) {
        if (userInfo.role != "candidate" || userInfo.isCompanyProfile) {
          navigate("/home", { replace: true });
          return false;
        }
      }
    }
    return true;
  };
  const checkPathsThatOnlyClientsHasAccess = () => {
    let pathsList = [
      {
        path: "/my-job-post",
        checkIncludes: true,
      },
      {
        path: "/job-candidates-page/",
        checkIncludes: true,
      },
      {
        path: "/candidates/",
        checkIncludes: true,
      },
      {
        path: "/payment-requests",
      },
      {
        path: "/payment-done/",
        checkIncludes: true,
      },
      {
        path: "/payment-requests/",
        checkIncludes: true,
      },
    ];

    for (const item of pathsList) {
      let pathMatch = item.checkIncludes
        ? path.includes(item.path)
        : path == item.path;
      if (pathMatch) {
        if (userInfo.role != "client" && !userInfo.isCompanyProfile) {
          navigate("/home", { replace: true });
          return false;
        }
      }
    }
    return true;
  };

  const get_sticky_value = () => {
    const height = document.querySelector(".left-sidebar")?.clientHeight;
    const vh = window.innerHeight;
    const final = -1 * height + vh;

    if (vh > height) {
      return 0;
    }

    return final;
  };

  useEffect(() => {
    if (
      !userAPIData ||
      (userAPIData?.role == "candidate" && path.includes("/feed-job-detail/"))
    ) {
      return;
    }

    if (!checkPathAccordingProfileAccess()) {
      return;
    }
    if (!checkPathsThatOnlyCandidatesHasAccess()) {
      return;
    }
    if (!checkPathsThatOnlyClientsHasAccess()) {
      return;
    }
    const sourceSlug = params?.source_slug; // /:source_slug
    let featureSlug = params?.feature_slug; // /:feature_slug
    let jobsSlug = params?.jobtype_slug; // /:job_slug
    let typeSlug = params?.type_slug; // /:type_slug

    const navbarList = userAPIData?.navbar || [];

    if (!sourceSlug) return; // no source → just continue

    // 1. Check if source exists in navbar
    const source = navbarList.find((s) => s.source_slug === sourceSlug);
    // if (!source) {
    //   console.log("Source not found");
    //   navigate("/home", { replace: true });
    //   return;
    // }

    if (!featureSlug && jobsSlug) {
      featureSlug = jobsSlug;
    }

    if (!featureSlug && typeSlug) {
      featureSlug = typeSlug;
    }

    // 2. If feature is present, validate against source.features
    if (featureSlug) {
      const isFeatureValid = source?.features?.some(
        (f) => f.slug === featureSlug
      );
      if (!isFeatureValid) {
        navigate(`/${sourceSlug}/home`, { replace: true });
        return;
      }
    }
  }, [params, navigate, userAPIData]);

  return (
    <>
      {cropModalOpen && (
        <>
          <FixedSizeImageCropper
            image={file}
            maxSize={{ width: 1080, height: 1080 }}
            onClose={() => setCropModalOpen(false)}
            aspectRatio={1 / 1}
            handleCropComplete={(file) => {
              setCroppedImage(URL.createObjectURL(file));
              setInputs((prev) => ({ ...prev, image: file }));
              setCropModalOpen(false);
            }}
            roundCropAreaPixels={true}
            open={cropModalOpen}
          />
        </>
      )}

      {emailFallBackOpen && (
        <MailFallbackModal
          open={emailFallBackOpen}
          handleClose={() => setEmailFallBackOpen(false)}
          emailData={emailData}
        />
      )}

      {openReportPost && (
        <ReportPostJobModal
          open={openReportPost}
          onClose={() => setOpenReportPost(false)}
          reportTo={reportData?.report_to}
          targetId={reportData?.post?._id}
          callBackFunction={reportData.callBackFunction}
        />
      )}

      {profileSwitchLoader && (
        <ProfileSwitchLoader
          open={profileSwitchLoader}
          text="Switching Profile.."
        />
      )}

      <Header setDrawerOpen={setDrawerOpen} />
      <GeneralMuiModal
        open={inputs.dialogOpen}
        setOpen={handleDialogClose}
        componentToPass={
          <>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <img
                className="de-flex text-center justify-cotent-center"
                alt="Profile"
                src={
                  croppedImage ||
                  (inputs.image && typeof inputs.image === "string"
                    ? s3baseUri + inputs.image
                    : "")
                }
                style={{ width: 200, height: 200, margin: "0 auto" }}
              />
            </div>
          </>
        }
      />
      <Box className={`main-body ${isSmallScreen ? "sm-screen" : "container"}`}>
        {!shouldHideSidebar && (
          <Box
            className="left-sidebar hide-on-sm"
            sx={{ top: get_sticky_value() }}
          >
            <Sidebar
              currentSidebar={currentSidebar}
              drawerOpen={drawerOpen}
              setDrawerOpen={setDrawerOpen}
            />
          </Box>
        )}

        <div className="main-content right-section no-scrollbar d-flex mx-auto">
          {(userInfo?.is_temporary_password === true ||
            (userInfo?.is_profile_completed === false &&
              userInfo?.role === "client")) && (
            <ProfileDialog
              userInfo={userInfo}
              openModal={openDelete}
              setOpenModal={setOpenDelete}
            />
          )}
          <Outlet />
        </div>
      </Box>
    </>
  );
};

export default DashboardLayout;
